module.exports = __webpack_public_path__ + "ad0ac34ae1992f036f6c4e3b50ae8dd5.MP3";